export default "__VITE_ASSET__JU6zWmtP__"